import React from 'react';
import { CDN_URI, createClanIconImageString } from '../../common/utilities';
import styles from './ClanEmblem.module.scss';


//inspired from code used in br clan page
export default function ClanEmblem({ data }) {
  if (
    data == null ||
    0 == data.markLayer01 ||
    0 == data.markLayer02 ||
    0 == data.markLayer03
  ) {
    return (
      <figure className={styles.clan_logo_class}>
        <img src={CDN_URI + "imgs/ClanMark/default_logo.png"} />
      </figure>
    );
  } else {
    return (
      <figure className={styles.clan_logo_class}>
        <img src={createClanIconImageString(data.markLayer01, 0)} />
        <img src={createClanIconImageString(data.markLayer02, 1)} />
        <img src={createClanIconImageString(data.markLayer03, 2)} />
      </figure>
    );
  }
}
